module.exports = __webpack_public_path__ + "img/frost.e2ef4d20.jpg";